import { createContext } from 'react';
import { NotesContextType } from 'types/NotesContextType';

export const NotesContext = createContext<NotesContextType|null>(null);
